import { Injectable } from '@angular/core';
import {EMPTY, expand, filter, map, Observable, reduce} from 'rxjs';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import { HttpService } from './http.service';
import { Customer } from 'src/app/shared/models/customer.interface';
import { Note } from '../../../shared/models/note.model';
import { ThirdPartyFullObject } from 'src/app/shared/models/third-party.interface';
import { ThirdPartyTypeInterface } from '../../../shared/models/third-party-type.interface';
import { ClientType } from 'src/app/shared/enums/client-type.enum';
import { API_VERSIONS } from '../../../shared/consts/api-versions.const';

export enum Access {
  RateStructure = 'toggle-rate-structure',
  Reinsurance = 'toggle-reinsurance',
}

@Injectable({
  providedIn: 'root',
})
export class ThirdPartiesApiService {
  constructor(private apiService: HttpService) {}

  create(customer: Customer): Observable<ApiResponse> {
    return this.apiService.postReq('/third-parties', customer);
  }

  update(id: number, customer: Customer): Observable<ApiResponse> {
    return this.apiService.putReq(`/third-parties/${id}`, customer);
  }

  getAllTypes(): Observable<ThirdPartyTypeInterface[]> {
    return this.apiService
      .getReq(`/types/get-all`, {params: {model:'thirdparty'}})
      .pipe(map(response => response.data));

    // let currentPage = 1;
    // return this.getTypes(currentPage).pipe(
    //   expand((response) => {
    //     if (response && response.data && response.data.length >= 10) {
    //       currentPage++;
    //       return this.getTypes(currentPage);
    //     } else {
    //       return EMPTY;
    //     }
    //   }),
    //   filter((response) => !!response),
    //   reduce((acc, response) => {
    //     if (response) {
    //       return acc.concat(response.data);
    //     }
    //     return acc;
    //   }, [] as ThirdPartyTypeInterface[])
    // );
  }

  getTypes(
    page: number = 1,
    params = {}
  ): Observable<ApiResponse<ThirdPartyTypeInterface[]>> {
    return this.apiService.getReq(`/${API_VERSIONS.TYPES}/types`, {
      params: {
        model: 'thirdparty',
        filter_by_active: 1,
        page: page,
        ...params,
      },
    });
  }

  getAll(params = {}): Observable<ApiResponse<ThirdPartyFullObject[]>> {
    return this.apiService.getReq('/third-parties', { params });
  }

  getTitles(): Observable<ApiResponse> {
    return this.apiService.getReq(`/${API_VERSIONS.TITLES}/titles`);
  }

  getCountries(): Observable<ApiResponse> {
    return this.apiService.getReq('/countries');
  }

  getStates(): Observable<ApiResponse> {
    return this.apiService.getReq('/states/paging', {
      params: { length: 1000 },
    });
  }

  getStatesByCountryId(id: number): Observable<ApiResponse> {
    return this.apiService.getReq(`/countries/${id}`, {
      params: { length: 1000 },
    });
  }

  getProducers(): Observable<ApiResponse> {
    return this.apiService.getReq(
      `/${API_VERSIONS.THIRD_PARTIES}/third-parties`,
      {
        params: {
          filter_by_type: 9,
        },
      }
    );
  }

  updateAccess(userId: number, access: Access): Observable<ApiResponse> {
    return this.apiService.getReq(`/users/${userId}/${access}`);
  }

  deleteNote(id: number): Observable<ApiResponse> {
    return this.apiService.deleteReq(`/note/${id}`);
  }

  updateNotePrivacy(id: number, note: Note): Observable<ApiResponse> {
    return this.apiService.putReq(`/note/${id}`, note);
  }

  getById(id: number): Observable<ApiResponse<ThirdPartyFullObject>> {
    return this.apiService.getReq(`/users/${id}`);
  }

  getAgentForms(): Observable<ApiResponse> {
    return this.apiService.getReq('/onboard/Agent/form');
  }

  getRequiredForms(clientType: ClientType): Observable<ApiResponse> {
    return this.apiService.getReq(`/onboard/${clientType}/form`);
  }

  addForm(
    userId: number,
    clientType: ClientType,
    formsIds: number[]
  ): Observable<ApiResponse> {
    return this.apiService.putReq(`/add-forms/member/${userId}`, {
      group: clientType,
      required_forms: formsIds,
    });
  }

  getAllGroupsUsers(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq(`/${API_VERSIONS.GROUPS}/groups`, { params });
  }

  uploadAvatar(userId: number, logoFile: FormData): Observable<ApiResponse> {
    return this.apiService.postReq(`/updateUserAvatar/${userId}`, logoFile);
  }

  getAllThirdParties(
    params: any
  ): Observable<ApiResponse<ThirdPartyTypeInterface[]>> {
    return this.apiService.getReq(
      `/${API_VERSIONS.THIRD_PARTIES}/third-parties`,
      {
        params,
      }
    );
  }

  getAllThirdPartiesPaginated(
    params: any
  ): Observable<ApiResponse<ThirdPartyTypeInterface[]>> {
    return this.apiService.getReq(
      `/${API_VERSIONS.THIRD_PARTIES}/third-parties/paging`,
      {
        params,
      }
    );
  }
}
